import comp from "./QuestionBarChartTooltipContent";
export default comp;
